import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import './Loader.css'

const VARIANT_COUNT = 8;

function Loader() {
	const { t } = useTranslation()
	const message = useMemo(() => {
		const index = Math.floor(Math.random() * VARIANT_COUNT) + 1;
		return t(`generating_activity_${index}`, { defaultValue: t('generating_activity') });
	}, [t]);

	return (
		<div className="loader-activity-wrapper">
			<span className="loader-activity" />
			<div className="loader-activity-text">
				{message}
			</div>
		</div>
	)
}

export default Loader
